import { YM_WINDOW_KEY } from '../const'

export const checkYmSDK = () => {
	const isDefined = !!window[YM_WINDOW_KEY]

	if (!isDefined) {
		console.warn(`ym is not defined!`)
	}

	return isDefined
}
